import {
  CreditTrackerAdminPage as CreditTrackerAdminPageProps,
  SiteSettings
} from '@/@types/content';
import withNav from '../hocs/withNav';

const CreditTrackerAdminPageComponent: React.FC<
  CreditTrackerAdminPageProps & SiteSettings
> = () => {
  return <>CREDIT TRACKER ADMIN</>;
};

const CreditTrackerAdminPage = withNav(CreditTrackerAdminPageComponent);
export default CreditTrackerAdminPage;
